var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contact"}},[_c('contact-form',{staticClass:"pt-60 md-pt-40"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }